import { EventEmitter } from '~utils/event_emitter';

export enum LogLevel {
  Info = 'INFO',
  Warning = 'WARNING',
  Error = 'ERROR',
}

export interface iErrorEvent {
  error: any | null;
  message?: string;
  context?: Record<string, any>;
  uncaught?: boolean;
  silent?: boolean;
  disableErrorNavigator?: boolean;
  loglevel?: LogLevel;
}

export interface iErrorEventHandler {
  handle(event: iErrorEvent): void;
}

export const errorEvent = new EventEmitter<iErrorEvent>();
